import moment from 'moment';
import {
  USER_ACTIVITIES_CHANGE_VALUE,
  USER_ACTIVITIES_CHANGE_TABLE_OPTION,
  USER_ACTIVITIES_CHANGE_VALUES,
} from '@/store/constants/mutationTypes';
import apiClient from '@shared/lib/general/apiClient';

const actions = {
  changeUserActivitiesValue({ commit }, payload) {
    const {
      field,
      value,
    } = payload;

    commit({
      type: USER_ACTIVITIES_CHANGE_VALUE,
      field,
      value,
    });
  },
  changeUserActivitiesValues({ commit }, payload) {
    commit({
      type: USER_ACTIVITIES_CHANGE_VALUES,
      changes: payload,
    });
  },
  uaChangeTableOption({ commit }, payload) {
    const {
      field,
      value,
    } = payload;

    commit({
      type: USER_ACTIVITIES_CHANGE_TABLE_OPTION,
      field,
      value,
    });
  },
  async getUserActivitiesPartners({ commit, rootState }, payload) {
    commit({
      type: USER_ACTIVITIES_CHANGE_VALUE,
      field: 'loading',
      value: true,
    });

    try {
      const {
        admin: {
          current: {
            corporationId,
          },
        },
      } = rootState;
      let cId = corporationId;

      if (payload && payload.corpId) {
        cId = payload.corpId;
        if (cId === 'all') {
          cId = -1;
        }
      }

      const { data: dataType } = await apiClient({
        method: 'GET',
        url: '/userevent/logs/activity/types',
      });
      const typeOptions = dataType.map((type) => ({
        label: type.description,
        value: type.event_code,
      }));
      typeOptions.unshift({
        label: 'Select Event',
        value: '',
      });
      commit({
        type: USER_ACTIVITIES_CHANGE_VALUES,
        changes: [{
          field: 'loading',
          value: false,
        }, {
          field: 'typeOptions',
          value: typeOptions,
        }, {
          field: 'selectedPartner',
          value: corporationId,
        }],
      });
    } catch (err) {
      commit({
        type: USER_ACTIVITIES_CHANGE_VALUE,
        field: 'loading',
        value: false,
      });
      throw err;
    }
  },

  async getUserActivities({ commit, state, rootState }) {
    commit({
      type: USER_ACTIVITIES_CHANGE_VALUE,
      field: 'loading',
      value: true,
    });
    try {
      const {
        admin: {
          current: {
            corporationId,
            corporation: {
              parent,
            },
          },
        },
      } = rootState;
      const {
        admin: {
          adminFilter: {
            corpId,
          },
        },
      } = rootState;
      const {
        selectedDate,
        selectedEventCode,
        uaTableOptions: {
          itemsPerPage,
          page,
        },
      } = state;

      const cId = parent ? corpId : corporationId;

      let url = `/userevent/logs/activity/corp/${cId}`;
      if (selectedDate && selectedDate.start && selectedDate.end) {
        const startDate = moment(selectedDate.start).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
        const endDate = moment(selectedDate.end).endOf('day').format('YYYY-MM-DDTHH:mm:ss');
        url += `?startDate=${startDate}&endDate=${endDate}`;
      } else {
        url += `?startDate=${moment().subtract(3, 'days').format('YYYY-MM-DDTHH:mm:ss')}`;
      }

      if (selectedEventCode) {
        url += `&eventCode=${selectedEventCode}`;
      } else {
        if (page) {
          url += `&offset=${page}`;
        }
        if (itemsPerPage) {
          url += `&limit=${itemsPerPage}`;
        }
      }

      const { data: userActivities } = await apiClient({
        method: 'GET',
        url,
      });

      commit({
        type: USER_ACTIVITIES_CHANGE_VALUES,
        changes: [{
          field: 'uaMembers',
          value: userActivities.data,
        }, {
          field: 'loading',
          value: false,
        },
        {
          field: 'uaTableOptions',
          value: {
            page: userActivities.page,
            itemsPerPage: userActivities.pageSize,
            totalItems: userActivities.totalCount,
          },
        }],
      });
    } catch (err) {
      console.error(err);
      commit({
        type: USER_ACTIVITIES_CHANGE_VALUE,
        field: 'loading',
        value: false,
      });
    }
  },
};

export default actions;
